module.exports = __webpack_public_path__ + "static/media/20190805_50Days2019_Tag13_0623AT.7086d23a.jpg";